export interface User {
    uid: string;
    displayName: string;
    email: string;
    userIdToken?: string;
}

export interface UserProfile {
    uid: string;
    displayName: string;
    email: string;
}

export type Survey = {
    id: string;
    title: string;
    description?: string;
    questions: Question[];
    responses: QuestionResponseResult[];
    creator: string;
    createdAt: Date | {seconds: number, nanoseconds: number};
    updatedAt: Date | {seconds: number, nanoseconds: number};
};

export type QuestionResponseResult = {
    questionId: string;
    questionText: string;
    questionType: string;
    results: Result[] | string[] | number[];
};

export type Result = {
    option: string;
    count: number;
}

export type Question = {
    id: string;
    questionText: string;
    type: typeof questionTypesArray[number];
    questionBody: QuestionType;
    options?: string[];
};

export type Response = {
    id: string;
    survey: Survey;
    surveyId: string;
    respondant: string;
    responses: QuestionResponse[];
    createdAt: Date;
    completedAt: Date | null;
    duration: number | Date| null;
};

export type QuestionResponse = {
    questionId: string;
    questionText: string;
    questionType: string;
    response: number | string | string[];
}

export const questionTypesArray: string[] = [
    'Multiple Choice',
    'Multiple Selection',
    'Dropdown Selection',
    'Short Response',
    'Multiple Choice Other',
    'Scale',
    'Rating',
    'Yes/No'
];

export type QuestionType = MultipleChoice | MultipleSelection | DropdownSelection | ShortResponse | MultipleChoiceOther | Scale | Rating | YesNo;

export type MultipleChoice = {
    options: string[];
}

export type MultipleSelection = {
    options: string[];
}

export type DropdownSelection = {
    options: string[];
}

export type ShortResponse = {
    questionText: string;
    setInputValue?: (input: string) => void;
};

export type MultipleChoiceOther = {
    options: string[];
    other: ShortResponse;
}

export type Scale = {
    min: number;
    max: number;
    step: number;
}

export type Rating = {
    min: number,
    max: number,
}

export type YesNo = {
    options: ['Yes', 'No'];
}

export function isMultipleChoice(questionBody: QuestionType): questionBody is MultipleChoice {
    return (questionBody as MultipleChoice).options !== undefined;
}

export function isMultipleSelection(questionBody: QuestionType): questionBody is MultipleSelection {
    return (questionBody as MultipleSelection).options !== undefined;
}

export function isDropdownSelection(questionBody: QuestionType): questionBody is DropdownSelection {
    return (questionBody as DropdownSelection).options !== undefined;
}

export function isShortResponse(questionBody: QuestionType): questionBody is ShortResponse {
    return (questionBody as ShortResponse).questionText !== undefined;
}

export function isMultipleChoiceOther(questionBody: QuestionType): questionBody is MultipleChoiceOther {
    return (questionBody as MultipleChoiceOther).other !== undefined;
}

export function isScale(questionBody: QuestionType): questionBody is Scale {
    return (questionBody as Scale).min !== undefined && (questionBody as Scale).max !== undefined && (questionBody as Scale).step !== undefined;
}

export function isRating(questionBody: QuestionType): questionBody is Rating {
    return (questionBody as Rating).min !== undefined && (questionBody as Rating).max !== undefined;
}

export function isYesNo(questionBody: QuestionType): questionBody is YesNo {
    return (questionBody as YesNo).options !== undefined && (questionBody as YesNo).options.includes('Yes') && (questionBody as YesNo).options.includes('No');
}

export function isResultArray(results: Result[] | string[] | number[]): results is Result[] {
    return (results as Result[])[0].option !== undefined && (results as Result[])[0].count !== undefined;
}




export const surveyData: Survey = {
    "createdAt": {
        "seconds": 1728001737,
        "nanoseconds": 885000000
    },
    "id": "7EA9QUuUY85R9v8LebYk",
    "creator": "lepaul.love@gmail.com",
    "title": "Mechanic Survey",
    "updatedAt": {
        "seconds": 1728250905,
        "nanoseconds": 327000000
    },
    "questions": [
        {
            "type": "Dropdown Selection",
            "questionBody": {
                "options": [
                    "Acura",
                    "Audi",
                    "BMW",
                    "Buick",
                    "Cadillac",
                    "Chevrolet",
                    "Dodge",
                    "Fiat",
                    "Ford",
                    "Genesis",
                    "GMC",
                    "Honda",
                    "Hyundai",
                    "Infiniti",
                    "Isuzu",
                    "Jaguar",
                    "Jeep",
                    "Kia",
                    "Land Rover",
                    "Lexus",
                    "Lincoln",
                    "Maserati",
                    "Mazda",
                    "Mercedes Benz",
                    "Nissan",
                    "Polestar",
                    "Porsche ",
                    "Rivian",
                    "Rolls Royce",
                    "Subaru",
                    "Tesla",
                    "Toyota",
                    "Volkswagen",
                    "Volvo",
                    "Other"
                ]
            },
            "id": "f0914c42-8b60-416b-acc5-22fdef391b76",
            "questionText": "What is the make of your vehicle?"
        },
        {
            "type": "Short Response",
            "questionText": "What is the model of your vehicle?",
            "questionBody": {
                "questionText": ""
            },
            "id": "3c30961a-6ef4-4355-8f86-3356f0a289a4"
        },
        {
            "questionText": "What is the model year of your vehicle?",
            "id": "11a13ee4-d5e5-463a-b56d-20ecd747eb19",
            "questionBody": {
                "options": [
                    "1990 - 2000",
                    "2001 - 2005",
                    "2006 - 2010",
                    "2011 - 2015",
                    "2016 - 2020",
                    "2021 - 2025"
                ]
            },
            "type": "Multiple Choice"
        },
        {
            "type": "Multiple Choice",
            "questionText": "When was the last time you took your car in for Routine Maintenance or a Repair?(Not including body work caused by an accident)?",
            "id": "bbe467d0-b7c4-4c53-9893-27e1b308e60c",
            "questionBody": {
                "options": [
                    "Within last 30 days",
                    "Within last 3 months",
                    "Within last 6 months",
                    "Within the last year",
                    "more than a year ago"
                ]
            }
        },
        {
            "questionText": "What is the most important factor when choosing a repair shop?",
            "id": "29e44afa-8eb9-42c9-a1e0-7beb4dc307b5",
            "questionBody": {
                "options": [
                    "Price",
                    "Reputation and Reviews",
                    "Speed of Service",
                    "Proximity/Location",
                    "Friendliness/Helpfulness of Staff",
                    "Trustworthiness"
                ]
            },
            "type": "Multiple Selection"
        },
        {
            "id": "a176a38a-e291-4e9c-aee0-0e71cae9017e",
            "type": "Multiple Choice",
            "questionText": "How did you schedule your car service?",
            "questionBody": {
                "options": [
                    "Called the shop directly",
                    "Scheduled online via the shop’s website/app",
                    "Walk-in without an appointment",
                    "Used a third-party app or service (e.g., YourMechanic, RepairPal)",
                    "Other"
                ]
            }
        },
        {
            "questionText": "What was your repair bill?",
            "id": "81b43080-bca4-44ad-a876-035819b058f9",
            "type": "Multiple Choice",
            "questionBody": {
                "options": [
                    "Less than $100",
                    "$100 - $300",
                    "$300 - $600",
                    "$600 - $900",
                    "over $900"
                ]
            }
        },
        {
            "type": "Multiple Choice",
            "id": "b8e868de-cea2-41b2-a1e6-0916b5044ab8",
            "questionBody": {
                "options": [
                    "Yes, the cost was as expected",
                    "No, it was higher than expected",
                    "No, it was lower than expected",
                    "No estimate was provided"
                ]
            },
            "questionText": "Was the final cost in line with the original estimate provided?"
        },
        {
            "questionBody": {
                "options": [
                    "Yes, and I used them",
                    "Yes, but I did not use them",
                    "No, no financing options were offered"
                ]
            },
            "type": "Multiple Choice",
            "questionText": "Did the repair shop offer any financing options for major repairs?",
            "id": "1b58b7b2-8df4-4246-ae82-1303520cce35"
        },
        {
            "id": "6d835be8-2555-470d-ad45-67187c84f643",
            "questionBody": {
                "options": [
                    "Warranty covered the entire bill",
                    "Car insurance covered the bill",
                    "I paid the dealer directly"
                ]
            },
            "questionText": "How did you cover the repair bill?",
            "type": "Multiple Choice"
        },
        {
            "type": "Multiple Choice",
            "questionBody": {
                "options": [
                    "YES",
                    "NO",
                    "Not sure yet (repairs were recent)"
                ]
            },
            "id": "8544f7d1-8036-4109-bd53-30352610eb44",
            "questionText": "Did you experience any issues after the repair was completed?"
        },
        {
            "type": "Multiple Choice",
            "questionText": "Did the shop offer a warranty on the repairs performed?",
            "id": "9ee8b3f3-3213-48b4-8a13-6fcb8130b53d",
            "questionBody": {
                "options": [
                    "YES",
                    "NO",
                    "I Don't Know"
                ]
            }
        },
        {
            "questionText": "What type of service was performed on your vehicle?",
            "id": "c1b06231-7f54-4650-84fc-cac9c6d1c539",
            "questionBody": {
                "options": [
                    "Routine Maintenance (Tires/Oil Change/Brakes/Fluid Exchange/ETC.)",
                    "Unexpected/Major repair(Engine rebuild/ transmission rebuild/water pump replacement/Leaks/ETC.)"
                ]
            },
            "type": "Multiple Choice"
        },
        {
            "questionBody": {
                "options": [
                    "Yes, the car was driven there by me or someone I know",
                    "Yes, someone at the repair shop picked it up for me",
                    "No, the car was towed"
                ]
            },
            "type": "Multiple Choice",
            "id": "1085ec89-7e3c-4466-b889-421085be4402",
            "questionText": "Did you drive the car to the shop yourself?"
        },
        {
            "id": "04512182-2bcc-4214-b086-bdd29bc1b6c7",
            "questionText": "Does/Did the Repair shop offer a Concierge Service to Pick-up and/or Drop-off the vehicle before and/or after the repairs?",
            "type": "Multiple Choice",
            "questionBody": {
                "options": [
                    "Yes, and I used it",
                    "Yes, but I didn't use it",
                    "No, but I wish they did",
                    "I don't know, I didn't ask"
                ]
            }
        },
        {
            "questionBody": {
                "options": [
                    "less than $20",
                    "$20 - $30",
                    "$31 - $40",
                    "$41 - $50",
                    "$51 - $60",
                    "$61 - $70",
                    "over $70"
                ]
            },
            "questionText": "How much did the pick-up and/or drop-off service cost?",
            "id": "4dc0da09-df9e-44da-8ef0-0c62ddfae0b4",
            "type": "Multiple Choice"
        },
        {
            "questionBody": {
                "options": [
                    "Dropped the car off and left the repair shop in a ride share",
                    "Dropped the car off and waited on a friend/family to pick me up",
                    "Dropped the car off and took a loaner from the repair shop",
                    "Dropped the car off and picked up a rental",
                    "I waited at the repair shop until the repairs were completed",
                    "N/A"
                ]
            },
            "id": "13416c88-b745-4433-8a4d-895ecfee8ead",
            "questionText": "Did you, or someone you know, drop the car off?",
            "type": "Multiple Choice"
        },
        {
            "id": "4402d0de-bd90-49ba-b970-243c05b89041",
            "questionBody": {
                "options": [
                    "Less than a day",
                    "1 - 2 days",
                    "3 - 5 days",
                    "More than 5 days",
                    "N/A"
                ]
            },
            "questionText": "If you dropped your car off, how long was your car in the repair shop?",
            "type": "Multiple Choice"
        },
        {
            "questionText": "If you did not drop the car off, how long were you left waiting at the repair shop?",
            "questionBody": {
                "options": [
                    "Less than 1 hour",
                    "1 - 2 hours",
                    "2 - 3 hours",
                    "3+ hours",
                    "N/A"
                ]
            },
            "type": "Multiple Choice",
            "id": "40da0e26-98f7-4320-8f1a-6ab92104be30"
        },
        {
            "questionText": "How far is the repair shop from your home or work?",
            "type": "Multiple Choice",
            "questionBody": {
                "options": [
                    "Less than 5 miles",
                    "5 - 10 miles",
                    "10 - 20 miles",
                    "More than 20 miles"
                ]
            },
            "id": "22316419-7098-4d0d-a840-5cd872695b5b"
        },
        {
            "id": "fc2804f0-12be-4b2c-925d-9f3f81a8ae6e",
            "questionText": "Do you have multiple working cars?",
            "questionBody": {
                "options": [
                    "Yes",
                    "No"
                ]
            },
            "type": "YesNo"
        }
    ],
    "description": "",
    "responses": []
}